
export default () => {
  return {
    schema: {}, // Holds the tables, columns, and rules of each filter
    counts: {}, // Holds the row counts of each filter at any given moment
    selections: {}, // Holds the list of valid filter selections,
    lastAppliedFilters: {}, // Holds the last applied filters, this is mainly used for cancel buttons
    filterOpen: false,
    openFilter: {},
    applied: true,
    inapplicability: {},
    sessionCache: {}
  }
}
